/**
 * Analytics Configuration Entity
 * Domain entity representing analytics configuration
 */
export class AnalyticsConfig {
    private constructor(
        public readonly measurementId: string,
        public readonly enabled: boolean,
        public readonly debug: boolean,
        public readonly testMode: boolean,
        public readonly options?: {
            cookieFlags?: string;
            cookieDomain?: string;
            cookieExpires?: number;
            anonymizeIp?: boolean;
        }
    ) { }

    static create(params: {
        measurementId: string;
        enabled?: boolean;
        debug?: boolean;
        testMode?: boolean;
        options?: {
            cookieFlags?: string;
            cookieDomain?: string;
            cookieExpires?: number;
            anonymizeIp?: boolean;
        };
    }): AnalyticsConfig {
        if (!params.measurementId || params.measurementId.trim() === '') {
            throw new Error('Analytics measurement ID is required');
        }

        return new AnalyticsConfig(
            params.measurementId,
            params.enabled ?? true,
            params.debug ?? false,
            params.testMode ?? false,
            params.options
        );
    }

    isActive(): boolean {
        return this.enabled && !this.testMode;
    }
}
